import { useEffect, useState } from 'react';
import clsx from 'clsx';
import {
  useAnnotationSolo,
  useMediaPlayer,
  useReplayAnnotation,
  useSelectionActions,
} from '@/features/comment-on-file';
import { getInitials } from '@/shared/utils/getInitials';
import { useMarkers } from './useMarkers';

export function VideoAnnotationBar() {
  const { mediaElement } = useMediaPlayer();
  const markers = useMarkers();
  const replay = useReplayAnnotation();
  const { soloCommentId } = useAnnotationSolo();
  const { selectComment, clearSelectedComment, requestScrollToComment } = useSelectionActions();

  const [duration, setDuration] = useState(0);

  useEffect(() => {
    if (!mediaElement) return;
    const onMeta = () =>
      setDuration(Number.isFinite(mediaElement.duration) ? mediaElement.duration : 0);
    mediaElement.addEventListener('loadedmetadata', onMeta);
    if (Number.isFinite(mediaElement.duration)) setDuration(mediaElement.duration);
    return () => mediaElement.removeEventListener('loadedmetadata', onMeta);
  }, [mediaElement]);

  if (!markers.length) return null;

  return (
    <div className="relative h-8 w-full border-b border-border bg-card">
      {markers.map((m) => {
        const left = duration > 0 ? (m.timecode / duration) * 100 : 0;
        const active = soloCommentId === m.commentId;
        return (
          <button
            key={m.commentId}
            type="button"
            onClick={() => {
              if (active) {
                clearSelectedComment();
              } else {
                selectComment(m.commentId);
                requestScrollToComment(m.commentId);
              }
              replay(m.commentId, m.annotation, m.versionId);
            }}
            aria-label={m.author.name}
            className={clsx(
              'absolute top-1/2 -translate-x-1/2 -translate-y-3/5 flex size-5 items-center justify-center rounded-full border text-[8px] transition-[border-color,background-color,color,box-shadow] duration-fast ease-out',
              active
                ? 'border-primary bg-accent text-foreground ring-0.5 ring-primary'
                : 'border-border text-foreground hover:border-primary',
            )}
            style={{ left: `${left}%` }}
          >
            {m.author.avatarUrl ? (
              <img
                src={m.author.avatarUrl}
                alt={m.author.name}
                className="size-full rounded-full object-cover"
              />
            ) : (
              getInitials(m.author.name)
            )}
          </button>
        );
      })}
    </div>
  );
}
